import React from "react";
import SbEditable from "storyblok-react"
import RichText from "src/utils/RichText";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import FluidImage from "src/utils/FluidImage";
import { Link } from "gatsby"
import resolveLink from "src/utils/resolveLink";
import ArrowButton from "src/components/ArrowButton"

const ThreeColumnPillarsItem = (props) => {
    const children =
    <>
        <div>
            <FluidImage image={props.image} className={`mx-auto mb-12 duration-300 ${props.target?.cached_url && 'group-hover:opacity-70'}`}/>
            <Heading size="h7" className={`text-darkblue mt-6 duration-300 font-bold uppercase !tracking-[1px] ${props.target?.cached_url && 'group-hover:text-brightgreen'}`}>
                <RichText>{props.title}</RichText>
            </Heading>
            <p className={`prose text-darkblue-700 mt-4 lg:text-base text-sm`}>
                <RichText>{props.description}</RichText>
            </p>
        </div>
        {props.target?.cached_url && <ArrowButton className="mt-8">{props.button_text}</ArrowButton>}
    </>
    return (
        props.target?.cached_url ?
        <Link className="group flex flex-col justify-end" to={resolveLink(props.target?.cached_url)}>
            {children}
        </Link>
        :
        <div className="group flex flex-col justify-end">
            {children}
        </div>
    )
}

const ThreeColumnPillars = ({blok}) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
        <div className={`relative bg-white`}>
            <div className={`relative max-w-6xl mx-auto px-6 lg:my-40 md:32 my-16`}>
                <div>
                    <Label className={`text-lightblue-300`} p={true}>{blok.label}</Label>
                    <Heading size="h2" className="text-darkblue mt-6 max-w-xl brightgreenBoldNormal">
                        <RichText>{blok.title}</RichText>
                    </Heading>
                    <p className="prose text-darkblue-700 max-w-xl mt-6">
                        <RichText>{blok.description}</RichText>
                    </p>
                    <img src={blok.image?.filename} alt={blok.image?.filename} className="absolute -top-40 right-0 lg:block hidden max-w-[400px]"/>
                </div>
                <div className="lg:mt-24 mt-16 grid lg:grid-cols-3 grid-cols-1 md:gap-48 gap-10">
                    {blok.items.map((item) => (
                        <ThreeColumnPillarsItem {...item} key={item._uid}/>    
                    ))}
                </div>
            </div>
        </div>
    </SbEditable>
  );
};

export default ThreeColumnPillars;
